module.exports = __webpack_public_path__ + "11a2fb8f7e6d9528bd51c5ddab0ee3d1.svg";